import './App.css';
import { PortfolioContextProvider } from "./Components/context";
import ThemeProvider from './Components/ThemeProvider';
import Main from './Components/Main';


const App = () => {
  return (
    <div className="App">
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem={false}
        disableTransitionOnChange
      >
        <PortfolioContextProvider>
          <Main />
        </PortfolioContextProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
